import React from 'react';

import ComponentHeader from '@totem/components/ComponentHeader';
import BackupSummaryCharts from '@totem/components/services/backup/deviceBackups/backupSummary/backupSummaryCharts';
import BackupSummaryContainer from '@totem/components/services/backup/deviceBackups/backupSummary/backupSummaryContainer';
import PageSectionBody from '@totem/components/ui_components/page/PageSectionBody';

const SummaryContainer = () => {
  return (
    <BackupSummaryContainer>
      <ComponentHeader title={'Continuity'} />
      <PageSectionBody>
        <BackupSummaryCharts />
      </PageSectionBody>
    </BackupSummaryContainer>
  );
};

export default SummaryContainer;
